module.exports = __webpack_public_path__ + "static/media/img5.5e695039.jpg";